
export const INCOME_FORM_SET = 'INCOME_FORM_SET';
export const INCOME_FORM_SET_KEY = 'INCOME_FORM_SET_KEY';
export const INCOME_FORM_RESET = 'INCOME_FORM_RESET';



// WEBPACK FOOTER //
// ./src/redux/incomeForm/types.js